import { useTranslation } from "react-i18next";

interface ScoreDisplayProps {
  score: number | undefined;
  label: string;
  className?: string;
  onClick?: () => void;
}

export function ScoreDisplay({ score, label, className = "", onClick }: ScoreDisplayProps) {
  const { t } = useTranslation();
  if (score === undefined) return null;

  return (
    <div
      className={`flex items-center gap-4 ${className} ${onClick ? "cursor-pointer hover:bg-gray-50" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div
        className={`text-5xl font-bold ${
          score >= 80 ? "text-green-600" : score >= 60 ? "text-yellow-600" : "text-red-600"
        }`}
      >
        {score.toFixed(0)}
      </div>
      <div>
        <h3 className="font-medium">{label}</h3>
        <p className="text-sm text-gray-500">
          {score >= 80
            ? t("thumbnailReviewer.results.excellent")
            : score >= 60
              ? t("thumbnailReviewer.results.good")
              : t("thumbnailReviewer.results.needsImprovement")}
        </p>
      </div>
    </div>
  );
}
